<template>
  <CModal
    title="รายละเอียดบทความ"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
    size="xl"
  >
    <CRow>
      <CCol sm="12">
        <h5 class="mb-3">
          <b>บทความ: {{ article.name }}</b>
        </h5>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="4">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol>
                <div>
                  <div>
                    <CImg
                      :src="article.imageUrl"
                      width="67"
                      height="67"
                      class="mx-auto"
                      placeholderColor="lightgray"
                      block
                    />
                  </div>
                </div>
                <div>
                  <div class="detail-key">รายละเอียดบทความ</div>
                  <div class="detail-value">{{ article.detail || '-' }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">ผู้อ่าน</div>
                  <div class="detail-value">{{ article.translatorName }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">วันที่สร้าง</div>
                  <div class="detail-value">
                    {{ article.createdAt | datetimeFormat }}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            ไฟล์เสียงทั้งหมด
          </CCardHeader>
          <CCardBody v-if="chapters.length > 0">
            <vue-good-table
              :columns="columns"
              :rows="chapters"
              max-height="500px"
              theme="black-rhino"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'play'">
                  <CButton
                    color="info"
                    size="sm"
                    class="m-1"
                    @click="playStart()"
                    :disabled="
                      !(isPlaying && currentSound === props.row.soundUrl)
                    "
                  >
                    <i class="fa fa-redo-alt"></i>
                    <span class="sr-only">เริ่มเล่นใหม่</span>
                  </CButton>
                  <CButton
                    color="success"
                    variant="outline"
                    size="sm"
                    class="m-1 ml-1"
                    @click="playBackward()"
                    :disabled="
                      !(isPlaying && currentSound === props.row.soundUrl)
                    "
                  >
                    <i class="fa fa-backward"></i>
                    <span class="sr-only">กรอถอยหลัง 5 วิ</span>
                  </CButton>
                  <CButton
                    :color="!isPlaying ? 'success' : 'danger'"
                    size="sm"
                    class="m-1"
                    @click="playSound(props.row.soundUrl)"
                  >
                    <i :class="!isPlaying ? 'fa fa-play' : 'fa fa-pause'"></i>
                    <span class="sr-only">{{!isPlaying ? 'เล่น' : 'หยุด'}}</span>
                  </CButton>
                  <CButton
                    color="success"
                    variant="outline"
                    size="sm"
                    class="m-1"
                    @click="playForward()"
                    :disabled="
                      !(isPlaying && currentSound === props.row.soundUrl)
                    "
                  >
                    <i class="fa fa-forward"></i>
                    <span class="sr-only">กรอเดินหน้า 5 วิ</span>
                  </CButton>
                  <CButton
                    color="info"
                    size="sm"
                    class="m-1"
                    @click="downloadMedia(props.row.soundUrl)"
                  >
                    <i class="fa fa-download"></i>
                    <span class="sr-only">ดาวน์โหลดไฟล์</span>
                  </CButton>
                </span>
              </template>
            </vue-good-table>
          </CCardBody>
          <CCardBody v-else align="center">
            ไม่พบข้อมูล
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <audio ref="myAudio" autoload>
      <source :src="currentSound" type="audio/mp3" />
      Your browser does not support the audio element.
    </audio>

    <template slot="footer">
      <CButton color="primary" @click="confirm">
        ปิด
      </CButton>
    </template>
  </CModal>
</template>

<script>
import _ from 'lodash'

import apiArticle from '@/apis/article'

export default {
  name: 'UserInfoModal',
  data() {
    return {
      isShow: false,
      article: {},
      chapters: [],
      columns: [
        {
          label: 'บทที่',
          field: 'chapterNo',
          width: '70px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ชื่อบท',
          field: 'name',
          sortable: false
        },
        {
          label: 'Media control',
          field: 'play',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          width: '230px'
        }
        // {
        //   field: 'action',
        //   sortable: false,
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        //   width: '110px'
        // }
      ],
      isPlaying: false,
      currentSound: null
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })
  },
  methods: {
    show(id) {
      this.isShow = true
      apiArticle
        .detail(id)
        .then((result) => {
          this.article = result.data.book
          this.chapters = result.data.chapters
        })
        .catch(() => {})
    },
    clear() {
      setTimeout(() => {
        this.info = {
          id: '',
          type: ''
        }
      }, 500)

      if (this.isPlaying) {
        this.$refs.myAudio.pause()
        this.$refs.myAudio.currentTime = 0

        this.isPlaying = false
        this.currentSound = null
      }
    },
    confirm() {
      this.isShow = false
      this.clear()
    },
    closeModal() {
      this.clear()
    },
    playSound(url) {
      this.currentSound = url
      // 'http://34.87.59.92:3000/media/audio/001/009/275/1009275_1486872_20200426_150658.mp3' //url
      try {
        if (!this.isPlaying) {
          if (this.currentSound) {
            this.$refs.myAudio.load()

            setTimeout(() => {
              this.$refs.myAudio.play()
            }, 300)
          }
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    playStart() {
      this.$refs.myAudio.currentTime = 0
    },
    playForward() {
      this.$refs.myAudio.currentTime += 5
    },
    playBackward() {
      this.$refs.myAudio.currentTime -= 5
    },
    downloadMedia(url) {
      let filename;
      if (url && url.indexOf('/') >= 0) {
        filename = url.split('/').pop()
      } else {
        filename = 'media_' + Date.now() + '.mp3';
      }

      let xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function(e) {
        if (this.status == 200) {
          const blob = this.response;
          const a = document.createElement("a");
          document.body.appendChild(a);
          const blobUrl = window.URL.createObjectURL(blob);
          a.href = blobUrl;
          a.download = filename;
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
          }, 0);
        }
      };
      xhr.send();
    }
  }
}
</script>
<style scope>
.title-name {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  margin: 25px 0;
}
</style>
